import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { siteConfig } from "@/config/site";

export default function CanonicalUpdater() {
  const { pathname } = useLocation();

  useEffect(() => {
    let link: HTMLLinkElement | null = document.querySelector("link[rel='canonical']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }

    if (pathname === "/" || pathname === "/home") {
      link.href = siteConfig.absoluteUrl("/");
    } else {
      link.href = siteConfig.absoluteUrl(pathname);
    }
  }, [pathname]);

  return null;
}